import React, {Component} from 'react'
import moment from 'moment';
import * as tz from 'moment-timezone'; //eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
         *  jquery.ui.widget.js
         *  jquery.ui.mouse.js
 */


export default class Calendar extends Component {
    getDateForUTCMidnightTimestamp(timestamp)   {
        let momentDate = moment.utc(timestamp * 1000);

        return new Date(momentDate.year(), momentDate.month(), momentDate.date());
    }

    constructor(props) {
        super(props);

        //clean timezone differences

        this.state = {
            date: '',
            time: '',
            from: 0,
            to: 86400
        };

        this.renderInput = this.renderInput.bind(this);
        this.saveRef = this.saveRef.bind(this);

        this.cnt = null;

    }

    setDate(date, datepicker) {
        let newDate = moment(date, 'YYYY-MM-DD').toDate();
        $(datepicker).datepicker('setDate', newDate);
    }

    componentDidMount() {
        let self = this;

        let fromDate = self.getDateForUTCMidnightTimestamp(self.props.fromDate);

        if (this.props.input) {
            document.addEventListener('click', function (event) {
                let ev = event || window.event;
                this.handleDocumentClick(ev);
            }.bind(this));

            this.initDatePicker({
                case: 'componentDidMount',
                dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                dateFormat: 'M d, yy ',
                defaultDate:  fromDate,
                onSelect: function (e) {
                    $('.reset.glyphicon').addClass('active');
                    this.renderInput(e);
                }.bind(self)
            });
        }
        if (this.props.static) {
            let newDate = moment(this.props.date, 'YYYY-MM-DD').toDate();
            this.initDatePicker({
                case: 'componentDidMount',
                dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                defaultDate:  fromDate,
                dateFormat: 'yy-mm-dd',
                onSelect: function (e) {
                    $('.reset.glyphicon').addClass('active');
                    this.renderInput(e);
                }.bind(self)
            }).datepicker('setDate', newDate);
        }
        else {

            self.updateResponsiveDatepicker(document);
            $(window).on('resize', function () {

                self.updateResponsiveDatepicker(document);

                self.drawMarkers();
            });

        }
        $('.ui-corner-all').on('click', function (event) {
            event.preventDefault();
        });
    }

    initDatePicker(config)    {
        config.onChangeMonthYear = (year, month, instance) => {

            this.props.changeMonth(instance.drawMonth, instance.drawYear)

        };

        if (this.props.forbidPast)  {
            config.minDate = moment.tz(this.props.timezone).format("Y-M-D");
        }

        return $(this.cnt).find(".datepicker").datepicker(config);

    }

    updateResponsiveDatepicker(el) {

        $(this.Datepicker).datepicker("destroy");

        let self = this;

        let fromDate = self.getDateForUTCMidnightTimestamp(self.props.fromDate);

        let viewportPercent = self.props.viewportWidth || 1;

        el = el || document;

        let elWidth = el.documentElement.clientWidth * viewportPercent;

        let config = {
            case: 'updateResponsiveDatepicker',
            dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            defaultDate:  fromDate,
            onSelect: function (e) {
                this.renderInput(e);
            }.bind(self)
        };

        //console.log('this.props.maxCalendarsCount', this.props.maxCalendarsCount)
        let monthsCount = 1;

        switch (true) {
            case elWidth > 1000:
                monthsCount = 4;

                break;

            case elWidth > 800 && elWidth <= 1000:
                monthsCount = 3;

                break;

            case elWidth > 500 && elWidth < 800:
                monthsCount = 2;

                break;

            default:
        }

        if (monthsCount > this.props.maxCalendarsCount) {
            monthsCount = this.props.maxCalendarsCount;
        }
        config.stepMonths = monthsCount;
        config.numberOfMonths = monthsCount;

        self.initDatePicker(config);
    }

    drawMarkers()   {

        let cnt = this.cnt;

        if (!cnt) return;

        let markers = cnt.querySelectorAll('.markers')
        for (let i = 0; i < markers.length; i++)    {
            let marker = markers[i];
            marker.classList.remove('book');
            marker.classList.remove('block');
            marker.classList.remove('available');

            while(marker.children.length > 0) {
                marker.children[0].remove();
            }
        }


        if (this.props.markers.length > 0) {
            this.props.markers.forEach(function (item, i, arr) {

                let date = moment.utc(item.date * 1000);
                let year = date.year();
                let month = date.month();
                let day = date.date();

                let block = '';
                let book = '';

                let markersClassList = ['markers'];

                if (item.available) {
                    markersClassList.push('available');
                }
                if (item.block) {
                    block = '<div class="block"></div>';
                }
                if (item.book) {
                    book = '<div class="book"></div>';
                }

                $(cnt).find('[data-year= ' + year + '][data-month=' + month + ']').each(function () {
                    let self = this;

                    if (Number($(self).find('a').text()) === Number(day)) {

                        let markerNode = $(self).find('.markers');
                        if (markerNode.length > 0) {

                            markersClassList.forEach(className => {
                                markerNode.addClass(className);
                            });

                            markerNode.html(book + block);
                        }
                        else {
                            let wrapper = '<div class="' + markersClassList.join(' ') + '"></div>';
                            $(self).append(wrapper);
                            $(self).find('.markers').html(book + block);
                        }
                    }
                })
            });
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.static) {
            if (prevProps.date !== this.props.date) {
                this.setDate(this.props.date, this.Datepicker);
            }

        }

        if (this.props.viewportWidth && prevProps.viewportWidth !== this.props.viewportWidth)   {
            this.updateResponsiveDatepicker(document);
        }

        setTimeout(this.drawMarkers.bind(this), 1);
    }


    renderComponent() {
        if (this.props.static) {
            return (
                <div style={{position: 'relative'}}>
                    <div className="datepicker_wrapper in static">
                        <div className="datepicker" ref={(datepicker) => {
                            this.Datepicker = datepicker
                        }}></div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="datepicker_wrapper in">
                    <div className="datepicker" ref={(datepicker) => {
                        this.Datepicker = datepicker
                    }}></div>
                </div>
            )

        }
    }

    renderInput(e) {
        this.setState({date: e}, function () {
            let obj = this.state;
            this.props.change(obj);
        });
    }


    handleDocumentClick(e) {
        if ($(e.target).closest(".datepicker_wrapper.toggle-picker").length ||
            $(e.target).closest('.ui-datepicker-header').length ||
            e.target.id === 'input-datepicker') {
            return
        }
        else {
            let togglePicker = $('.datepicker_wrapper.toggle-picker');
            if (togglePicker.hasClass('in')) {
                togglePicker.removeClass('in')
            }
        }
    }

    saveRef(el) {
        if (el) {
            this.cnt = el;
        }
    }

    render() {
        return (
            <div ref={this.saveRef}>
                {this.renderComponent()}
                {this.props.children}
            </div>
        )
    }
}

Calendar.propTypes = {
    changeMonth: PropTypes.func,
    markers: PropTypes.array,
    time: PropTypes.string,
    date: PropTypes.string,
    fromDate: PropTypes.number,
    viewportWidth: PropTypes.number,
    maxCalendarsCount: PropTypes.number
};

let date = new Date();
let fromDate = Date.UTC(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0) / 1000;

Calendar.defaultProps = {
    changeMonth: function () {
        return false
    },
    markers: [],
    fromDate: fromDate,
    maxCalendarsCount: 4,
    forbidPast: false,
    timezone: "America/New_York"
};

Calendar.propTypes = {
    forbidPast: PropTypes.bool,
    timezone: PropTypes.string

};